import { UIMS_BASE } from '@/shared/utils';
import { summaryMap } from './summaryMap';
/**
 * 获取跳转url总入口
 * @param row
 * @param customProps
 * @returns
 */
export const getPathNameByRow = (row = {}, customProps = {}, ...other) => {
    const businessCode = row.businessCode || row.busCode;
    if (!businessCode) {
        return '';
    }
    const map = summaryMap;
    const item = map[businessCode];
    const itemType = typeof item;
    if (itemType === 'string') {
        return item;
    }
    if (itemType === 'function') {
        const result = item(row, customProps, ...other);
        // 返回所有的参数，主要是获取系统基础路由的参数, 从而动态获取子系统基础路由
        if (customProps?.returnJumpResponseAll === true) {
            return result;
        }
        return result.path ?? result;
    }
    return '';
};
export const otherSysPathNameMap = (() => {
    return {
        /**
         * @description 全部待办/
         */
        AllToDo: `${UIMS_BASE}/backlog/`,
        /**
         * @description 企业管理base
         */
        UimsBase: `${UIMS_BASE}/`,
        /**
         * @description 企业管理组织与员工
         */
        UimsOrg: `${UIMS_BASE}/orgStructure/organization`,
        /**
         * @description 更多通知公告type2
         */
        UimsNotice: `${UIMS_BASE}/notice?type=1`,
        /**
         * @description 企业管理组织与员工
         */
        UimsNoticeType2: `${UIMS_BASE}/notice?type=2`,
        /**
         * @description 消息中心
         */
        MessageList: `/m/190149157363683424/message/messageList/`,
        /**
         * @description 在线帮助pc端
         */
        SupportIndex: `/cms/support/support-index/`,
    };
})();
